import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
  Grid
} from '@mui/material';
import members from '../data/members.json';

const About: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        // Same center alignment as before
        padding: 4,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant={isMobile ? 'h4' : 'h3'}
        sx={{ mb: 4, color: theme.palette.secondary.main }}
      >
        Meet the Band
      </Typography>

      <Card
        sx={{
          maxWidth: isMobile ? '90%' : 600,
          margin: '0 auto',
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.secondary,
        }}
      >
        <CardContent>
          {/* 2 columns on desktop, 1 on mobile */}
          <Grid container spacing={2} justifyContent="center">
            {members.map((member, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <Box
                  sx={{
                    // Optionally force a square shape:
                    aspectRatio: '1 / 1',  // modern browsers
                    // Fallback (if older browsers):
                    // height: 0,
                    // paddingBottom: '100%',
                    // position: 'relative',
                    
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: `1px solid ${theme.palette.grey[700]}`,
                    background: `${theme.palette.secondary}`,
                    padding: 2,
                  }}
                >
                  <Typography variant="h5" sx={{ mb: 1 }}>
                    {member.name}
                  </Typography>
                  <Typography variant="body2">
                    {member.role}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default About;
